/* Neanour: lange teksten onder de koopsectie op mobiel inklappen met "Read more". Niets wordt verwijderd. */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var S = window.neaStrings || { readMore: 'Read more', readLess: 'Read less' };

  function setup() {
    if (!mq.matches) return;
    document.querySelectorAll('[id*="image_with_text"] .m-richtext__description').forEach(function (el) {
      if (el.dataset.neaClamp || el.scrollHeight <= 200) return;
      el.dataset.neaClamp = '1';
      el.classList.add('nea-clamp');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nea-clamp__toggle';
      btn.textContent = S.readMore;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.textContent = open ? S.readLess : S.readMore;
        btn.setAttribute('aria-expanded', String(open));
      });
      el.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();

/* Neanour: lijstnaam zichtbaar onder elk rondje (Black / Wood / Brown) */
(function () {
  function names() {
    document.querySelectorAll('variant-color .m-product-option--node[data-value]').forEach(function (node) {
      if (node.querySelector('.nea-swatch-name')) return;
      var span = document.createElement('span');
      span.className = 'nea-swatch-name';
      span.setAttribute('aria-hidden', 'true');
      const nlShort = { zwarte: 'Zwart', witte: 'Wit', houten: 'Hout', bruine: 'Bruin' };
      const short = node.dataset.value.replace(/\s*(frame|lijst)$/i, '');
      span.textContent = /^(no|geen|zonder)$/i.test(short) ? node.dataset.value : (nlShort[short.toLowerCase()] || short);
      node.appendChild(span);
    });
  }
  if (document.readyState !== 'loading') names();
  else document.addEventListener('DOMContentLoaded', names);
})();
